import { isTableauAppendRowsArg } from "../tableau-types";
import { reportErrorReason } from "./helpers/general-helpers";
var Profiles = /** @class */ (function () {
    function Profiles() {
        this.id = 'profiles';
        this.alias = 'Customer Profiles';
    }
    Profiles.prototype.getData = function (connector, table, done) {
        connector.getApiClient().fetchCustomerProfiles()
            .then(function (response) { return response.json(); })
            .then(function (data) {
            // groups aren't a valid format here
            var tableauData = data.data.map(function (profile) { return ({
                customer_profile_id: profile.customer_profile_id,
                network_type: profile.network_type,
                name: profile.name,
                native_name: profile.native_name,
                native_id: profile.native_id,
            }); });
            if (isTableauAppendRowsArg(tableauData)) {
                table.appendRows(tableauData);
            }
            else {
                console.error('Unknown Profiles data format', tableauData);
                throw new Error('Unknown Profiles data format');
            }
        })
            .then(done)
            .catch(function (reason) { return reportErrorReason(reason, connector.getTableau()); });
    };
    Profiles.prototype.getTableInfo = function () {
        return {
            id: this.id,
            alias: this.alias,
            columns: [
                {
                    id: 'customer_profile_id',
                    dataType: 'int',
                    alias: 'Customer Profile ID',
                    description: 'The customer profile ID used by Sprout to identify this social network profile.',
                },
                {
                    id: 'network_type',
                    dataType: 'string',
                    alias: 'Network Type',
                    description: 'The type of social network (c.f. Twitter, Facebook, Instagram, etc.)',
                },
                {
                    id: 'name',
                    dataType: 'string',
                    alias: 'Name',
                    description: 'The human-facing name of the social network profile',
                },
                {
                    id: 'native_name',
                    dataType: 'string',
                    alias: 'Native Name',
                    description: 'The user name, screen name, page URL, etc. the social network uses to identify a unique profile.',
                },
                {
                    id: 'native_id',
                    dataType: 'string',
                    alias: 'Native ID',
                    description: 'The ID used by the social network to identify a unique profile.',
                },
            ],
        };
    };
    return Profiles;
}());
export default Profiles;
